import { Carousel, NewsCard } from '@frontend-libs/portal';

import { NewsModel } from '@portal-clients/news';

import { tApp } from '@frontend/locales';

export interface NewsCarouselProps {
  onClick: (id: string) => void;
  newsList: NewsModel[];
  portalId: string;
}

export const NewsCarousel = ({
  onClick,
  newsList,
  portalId,
}: NewsCarouselProps) => {
  const a11y = tApp.news.a11y;

  return (
    <Carousel
      offsetCards
      a11y={{
        firstSlideMessage: a11y.firstSlideMessage(),
        lastSlideMessage: a11y.lastSlideMessage(),
        prevSlideMessage: a11y.previousSlideMessage(),
        nextSlideMessage: a11y.nextSlideMessage(),
        paginationBulletMessage: (index) =>
          a11y.goToArticle({
            index,
          }),
      }}
    >
      {newsList.map((news) => (
        <NewsCard
          key={news.id}
          title={news.title}
          description={news.description}
          publishDate={news.publishDate}
          portalId={portalId}
          imageUrl={news.image ? news.image.imageUrl : news.imageUrl}
          imageAltText={news.image?.altText}
          onClick={() => {
            onClick(news.id);
          }}
        />
      ))}
    </Carousel>
  );
};
